/**
 * Audio levels below this are background noise or silence. Everything that draws a level renders them exactly
 * like 0 - the indicator bars light from 0.08 and the speaking glow from 0.15 - yet a microphone's noise keeps
 * changing the raw value several times a second.
 */
const AUDIO_LEVEL_NOISE_FLOOR = 0.01;

/**
 * Maps the inaudible range of an audio level to 0, so a component can skip re-rendering while nobody is speaking.
 * Levels above the noise floor are returned unchanged (not clamped - remote levels can exceed 1 and the speaking
 * glow scales with them), so nothing that is drawn changes.
 *
 * @param {number} audioLevel - The raw audio level.
 * @returns {number}
 */
export function normalizeAudioLevel(audioLevel) {
    if (typeof audioLevel !== 'number' || isNaN(audioLevel) || audioLevel < AUDIO_LEVEL_NOISE_FLOOR) {
        return 0;
    }

    return audioLevel;
}
